import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '../slices';

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Auth hook
export const useAuth = () => {
  const { user, isAuthenticated, loading, error } = useAppSelector((state) => state.auth);
  return { user, isAuthenticated, loading, error };
};

// Permission check hook
export const usePermission = (permission: string) => {
  const { user } = useAuth();
  if (!user?.role?.permissions) return false;
  return user.role.permissions[permission] === true || user.role.permissions['all'] === true;
};

// Role check hook
export const useRole = () => {
  const { user } = useAuth();
  return user?.role?.name || null;
};

// Is Admin hook
export const useIsAdmin = () => {
  const role = useRole();
  return role === 'ADMIN';
};

// Is Forman hook
export const useIsForman = () => {
  const role = useRole();
  return role === 'FORMEN';
};

// Is Muhasebe hook
export const useIsMuhasebe = () => {
  const role = useRole();
  return role === 'MUHASEBE';
};
